import {HttpRequest} from '../utils/httpRequest';

let SysUser = {
    /**
     * 获取所有系统用户
     * @param datas
     * @returns {*}
     */
    getSysUserList: function (datas) {
        return HttpRequest.getRequest({
            method: 'get',
            url: '/sys/user/list',
            data: datas
        });
    },
    /**
     * 获取用户信息（根据id）
     * @param datas
     * @returns {*}
     */
    getSysUserInfo: function (datas) {
        return HttpRequest.getRequest({
            method: 'get',
            url: '/sys/user/info/' + datas
        });
    },
    /**
     * 新增或编辑系统用户
     * @param id
     * @param datas
     */
    addOrUpdateSysUser: function (type, datas) {
        return HttpRequest.getRequest({
            method: 'post',
            url: '/sys/user/' + type,
            data: datas
        });
    },
    /**
     * 删除
     * @param datas
     * @returns {*}
     */
    deleteSysUser(datas) {
        return HttpRequest.getRequest({
            method: 'get',
            url: '/sys/user/delete',
            data: datas
        });
    }

};
export {SysUser}
